import { render, staticRenderFns } from "./IconImage.vue?vue&type=template&id=503f964a&"
import script from "./IconImage.vue?vue&type=script&lang=js&"
export * from "./IconImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports